var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.145 10.1787C35.9202 10.707 34.5873 11.0873 33.2144 11.2354C34.6398 10.3886 35.7072 9.05077 36.2164 7.47295C34.8788 8.26862 33.4136 8.82656 31.8855 9.12202C31.2469 8.43928 30.4745 7.89538 29.6165 7.52421C28.7585 7.15304 27.8332 6.96255 26.8983 6.96462C23.1159 6.96462 20.0739 10.0306 20.0739 13.793C20.0739 14.3214 20.1379 14.8497 20.242 15.3581C14.5783 15.0619 9.52705 12.3561 6.16887 8.21343C5.55697 9.25857 5.23632 10.4486 5.24026 11.6597C5.24026 14.0292 6.44505 16.1186 8.28224 17.3474C7.19955 17.3047 6.14222 17.0071 5.19624 16.4788V16.5628C5.19624 19.881 7.54176 22.6308 10.6678 23.2632C10.0808 23.4157 9.47704 23.4936 8.87062 23.4953C8.42633 23.4953 8.00606 23.4513 7.58178 23.3913C8.44634 26.097 10.964 28.0623 13.9619 28.1263C11.6164 29.9635 8.67849 31.0442 5.48843 31.0442C4.91605 31.0442 4.38771 31.0242 3.83936 30.9602C6.86532 32.9014 10.4556 34.0222 14.3222 34.0222C26.8743 34.0222 33.7428 23.6234 33.7428 14.5976C33.7428 14.3014 33.7428 14.0052 33.7227 13.709C35.0516 12.7364 36.2164 11.5316 37.145 10.1787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1ec0b4c2abed6d5ac0023cdf1a751234.svg";
export { ForwardRef as ReactComponent };